const widgetDownload = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.75 7.5V12h8.5V7.5h1.5v6H2.25v-6zM8.843 2l-.001 5h2.698L8 10.677 4.46 7h2.739L7.2 2z"/></svg>',
};

export { widgetDownload as default };
